import { FC, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { UserLoyaltyProgramForm } from "Bands/components";
import { editUserLoyaltyProgram, userLoyaltyProgramSelectorCreator } from "Bands/state";
import { IUserLoyaltyProgramPatchData, USER_ACTIONS } from "Bands/types";
import { copy } from "shared/assets";
import { IFormButtons } from "shared/types";
import { UserEntityModal } from "Bands/containers";
import { Passport } from "shared/assets/icons";

const { userLoyaltyProgram: loyaltyCopy } = copy;

interface Props {
  id: string;
  handleClose: () => void;
}

export const EditUserLoyaltyProgramModal: FC<Props> = ({ id, handleClose }) => {
  const dispatch = useDispatch();

  const programIdSelector = useMemo(() => userLoyaltyProgramSelectorCreator(id), [id]);
  const program = useSelector(programIdSelector);

  const buttons: IFormButtons = {
    secondary: {
      onClick: handleClose,
    },
  };

  const handleSubmit = (data: IUserLoyaltyProgramPatchData) => {
    dispatch(editUserLoyaltyProgram({ id, data }));
  };

  return (
    <UserEntityModal
      defaultValues={program}
      title={loyaltyCopy.edit.title}
      icon={Passport}
      action={USER_ACTIONS.editUserLoyaltyProgram}
      buttons={buttons}
      successMessage={loyaltyCopy.messages.edited}
      Component={UserLoyaltyProgramForm}
      handleSubmit={handleSubmit}
      handleClose={handleClose}
    />
  );
};
